import React, { useState } from 'react';
import axios from 'axios';
import { Receipt, Loader2 } from 'lucide-react';
import { Button } from '../ui/button';
import { toast } from 'sonner';
import { CashCountDialog } from './CashCountDialog';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const eur = (v) => `€${(v || 0).toFixed(2)}`;
const row = (label, value, cls = '') => `<tr class="${cls}"><td>${label}</td><td class="num">${value}</td></tr>`;
const diffText = (v) => Math.abs(v) < 0.005 ? 'TAM' : v > 0 ? `FAZLA +${eur(v)}` : `EKSİK -${eur(-v)}`;
const diffColor = (v) => Math.abs(v) < 0.005 ? '#1a7f37' : v > 0 ? '#b26b00' : '#c62828';

const countHtml = (c) => `<h2>KASA SAYIMI${c.cashier ? ` · Kasiyer: ${c.cashier}` : ''}</h2>
  <table><tr><th></th><th class="num">Beklenen</th><th class="num">Sayılan</th><th class="num">Fark</th></tr>
  ${[['Nakit', c.expected_cash, c.counted_cash, c.diff_cash], ['Kart (POS)', c.expected_card, c.counted_card, c.diff_card]].map(([l, e, s, f]) =>
    `<tr><td><b>${l}</b></td><td class="num">${eur(e)}</td><td class="num">${eur(s)}</td><td class="num" style="font-weight:900;color:${diffColor(f)}">${diffText(f)}</td></tr>`).join('')}
  </table>${c.note ? `<p style="margin-top:6px;font-size:12px"><b>Not:</b> ${c.note}</p>` : ''}
  <p style="margin-top:4px;font-size:10px;color:#777">Sayım kaydı: ${new Date(c.updated_at).toLocaleString('tr-TR')}</p>`;

const buildHtml = (d) => {
  const [y, m, day] = d.date.split('-');
  const waiterRows = d.waiters.map(w => `<tr><td>${w.name}</td><td class="num">${w.count}</td><td class="num">${eur(w.nakit)}</td><td class="num">${eur(w.kart)}</td><td class="num">${eur(w.veresiye)}</td><td class="num"><b>${eur(w.nakit + w.kart + w.veresiye)}</b></td></tr>`).join('');
  return `<!DOCTYPE html><html><head><meta charset="UTF-8"><title>Gün Sonu ${d.date}</title>
  <style>*{margin:0;padding:0;box-sizing:border-box}body{font-family:Arial,sans-serif;padding:28px 34px;font-size:13px;color:#111}
  h1{font-size:22px;letter-spacing:1px}.sub{color:#555;margin:4px 0 18px}h2{font-size:14px;margin:18px 0 8px;padding-bottom:4px;border-bottom:2px solid #111;letter-spacing:.5px}
  .cards{display:flex;gap:12px;margin-bottom:6px}.card{flex:1;border:2px solid #111;padding:12px;text-align:center}.card .v{font-size:22px;font-weight:900}.card .l{font-size:10px;color:#555;letter-spacing:1px;margin-top:2px}
  .card.main{background:#111;color:#fff}.card.main .l{color:#ddd}
  table{width:100%;border-collapse:collapse}td,th{border:1px solid #bbb;padding:6px 8px;text-align:left}th{background:#eee}td.num,th.num{text-align:right}
  .total td{font-weight:900;background:#f2f2f2}.muted td{color:#777}.cols{display:flex;gap:18px}.cols>div{flex:1}
  .sign{display:flex;gap:40px;margin-top:40px}.sign div{flex:1;border-top:1px solid #111;padding-top:6px;text-align:center;font-size:11px;color:#555}
  @media print{body{padding:12mm}}</style></head><body>
  <h1>CENTRAL RESTAURANT · GÜN SONU ÖZETİ</h1>
  <p class="sub">${day}.${m}.${y} · ${d.order_count} satış · Yazdırma: ${new Date().toLocaleString('tr-TR')}</p>
  <div class="cards">
    <div class="card main"><div class="v">${eur(d.cash_register.total)}</div><div class="l">KASA TOPLAMI (NAKİT+KART)</div></div>
    <div class="card"><div class="v">${eur(d.cash_register.nakit)}</div><div class="l">KASADA NAKİT</div></div>
    <div class="card"><div class="v">${eur(d.cash_register.kart)}</div><div class="l">KART (POS)</div></div>
    <div class="card"><div class="v">${eur(d.sales.veresiye)}</div><div class="l">VERESİYE (AÇIK HESAP)</div></div>
  </div>
  ${d.cash_count ? countHtml(d.cash_count) : ''}
  <div class="cols"><div>
  <h2>KASA HESABI</h2><table>
    ${row('Nakit satışlar', eur(d.sales.nakit))}
    ${row(`Veresiye tahsilatı - nakit`, eur(d.collections.nakit))}
    ${row('= Kasada olması gereken nakit', eur(d.cash_register.nakit), 'total')}
    ${row('Kart satışlar', eur(d.sales.kart))}
    ${row('Veresiye tahsilatı - kart', eur(d.collections.kart))}
    ${row('= Toplam kart (POS)', eur(d.cash_register.kart), 'total')}
    ${row('Bugün veresiyeye yazılan', eur(d.sales.veresiye))}
    ${d.collections.havale ? row('Veresiye tahsilatı - havale (kasaya girmez)', eur(d.collections.havale)) : ''}
    ${d.open_orders?.count ? row(`Açık/kapanmamış siparişler (${d.open_orders.count}) - kasaya girmez`, eur(d.open_orders.amount)) : ''}
    ${row(`Toplam ciro (nakit+kart+veresiye satış)`, eur(d.total_revenue), 'total')}
  </table></div><div>
  <h2>SATIŞ GRUPLARI</h2><table><tr><th>Grup</th><th class="num">Adet</th><th class="num">Ciro</th></tr>
    ${d.groups.map(g => `<tr><td>${g.label}</td><td class="num">${g.count}</td><td class="num">${eur(g.revenue)}</td></tr>`).join('')}
    <tr class="muted"><td>İptal (ciroya dahil değil)</td><td class="num">${d.cancelled.count}</td><td class="num">${eur(d.cancelled.amount)}</td></tr>
  </table></div></div>
  ${d.waiters.length ? `<h2>GARSON BAZLI</h2><table><tr><th>Garson</th><th class="num">Satış</th><th class="num">Nakit</th><th class="num">Kart</th><th class="num">Veresiye</th><th class="num">Toplam</th></tr>${waiterRows}</table>` : ''}
  ${d.top_products.length ? `<h2>EN ÇOK SATANLAR</h2><table><tr><th>#</th><th>Ürün</th><th class="num">Adet</th><th class="num">Ciro</th></tr>${d.top_products.map((p, i) => `<tr><td>${i + 1}</td><td>${p.name}</td><td class="num">${p.quantity}</td><td class="num">${eur(p.revenue)}</td></tr>`).join('')}</table>` : ''}
  <div class="sign"><div>Kasiyer</div><div>Yönetici</div></div>
  </body></html>`;
};

const printHtml = (html) => {
  const iframe = document.createElement('iframe');
  iframe.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:0;visibility:hidden;';
  document.body.appendChild(iframe);
  const doc = iframe.contentDocument || iframe.contentWindow.document;
  doc.open(); doc.write(html); doc.close();
  setTimeout(() => {
    iframe.contentWindow.focus(); iframe.contentWindow.print();
    setTimeout(() => { try { document.body.removeChild(iframe); } catch (e) { /* removed */ } }, 3000);
  }, 300);
};

export const EndOfDayButton = ({ token, date }) => {
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [eod, setEod] = useState(null);
  const [form, setForm] = useState({ cash: '', card: '', cashier: '', note: '' });
  const headers = { Authorization: `Bearer ${token}` };

  const open = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API}/admin/reports/end-of-day?date=${date}`, { headers });
      const c = res.data.cash_count;
      setForm({ cash: c ? String(c.counted_cash) : '', card: c ? String(c.counted_card) : '', cashier: c?.cashier || '', note: c?.note || '' });
      setEod(res.data);
    } catch {
      toast.error('Gün sonu özeti alınamadı');
    } finally { setLoading(false); }
  };

  const saveAndPrint = async () => {
    if (form.cash === '' || form.card === '') { toast.error('Sayılan nakit ve POS tutarını girin'); return; }
    setSaving(true);
    try {
      const res = await axios.post(`${API}/admin/reports/cash-count`, {
        date, counted_cash: parseFloat(form.cash) || 0, counted_card: parseFloat(form.card) || 0, cashier: form.cashier, note: form.note
      }, { headers });
      toast.success('Kasa sayımı kaydedildi');
      printHtml(buildHtml({ ...eod, cash_count: res.data }));
      setEod(null);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Sayım kaydedilemedi');
    } finally { setSaving(false); }
  };

  return (
    <>
      <Button onClick={open} disabled={loading} className="bg-charcoal text-white hover:bg-charcoal/90" data-testid="end-of-day-btn">
        {loading ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Receipt className="w-4 h-4 mr-2" />}
        Gün Sonu Özeti ({date.split('-').reverse().join('.')})
      </Button>
      <CashCountDialog eod={eod} form={form} setForm={setForm} saving={saving} onClose={() => setEod(null)}
        onSave={saveAndPrint} onPrintOnly={() => { printHtml(buildHtml({ ...eod, cash_count: null })); setEod(null); }} />
    </>
  );
};

export default EndOfDayButton;
